import { createSlice } from "@reduxjs/toolkit";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import {
    Call,
    CallWithFormDataFile,
    downloadFileFromLink,
} from "../../../helpers/fetch";
import { errorHandler } from "../../../helpers/errorHandler";
import Swal from "sweetalert2";

const initialState = {
    modal: false,
    pagination: {
        data: [],
        per_page: 10,
    },
};

export const schoolControls = createSlice({
    name: "schoolControls",
    initialState,
    reducers: {
        toggleModal: (state) => {
            state.modal = !state.modal;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
    },
});

export const { toggleModal, setPagination } = schoolControls.actions;

export default schoolControls.reducer;

//*Actions

export const startGetSchoolControlReports = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const urlParams = new URLSearchParams();
        if (values?.query !== "") urlParams.set("q", values?.query);
        if (values?.number_rows) urlParams.set("per_page", values?.number_rows);
        if (values?.page) urlParams.set("page", values?.page);
        const resp = await Call(
            `operators/school/control/reports`,
            "GET",
            urlParams.toString()
        );
        if (resp.success) {
            dispatch(setPagination(resp.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startGetDownloadUri = (school_control_report_id) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call(
            `operators/school/control/reports/uri/${school_control_report_id}`,
            "GET"
        );
        if (resp.success) {
            downloadFileFromLink(resp.success.uri, resp.success.fileName);
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startCreateReportByType = (values, onSuccess) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call(
            `operators/school/control/reports/create`,
            "PUT",
            values
        );
        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
            dispatch(startGetDownloadUri(resp.success.id));
            onSuccess();
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};
